import React from "react";
import { OneContactInfo } from "./OneContactInfo";
import { controllers } from "../../Controllers/Controllers";
import FooterSection from "./Section/FooterSection";

class FooterView extends React.Component {

    render(){
        return <div className="footer-view">
        </div>
    }
}

export { FooterView }